import {
  SquareArrowRight,
  SquarePlus,
  SquareFunction,
  SquareAsterisk,
  SquareScissors,
  LucideIcon,
} from 'lucide-react';

export interface PlaybookTransformConfig {
  type: 'mapping' | 'enrichment' | 'expression' | 'spreading' | 'filter';
  label: string;
  icon: LucideIcon;
  colorClass: string; // Tailwind CSS class for background and text
}

export const PLAYBOOK_TRANSFORM_CONFIGS: PlaybookTransformConfig[] = [
  {
    type: 'mapping',
    label: 'Mapping',
    icon: SquareArrowRight,
    colorClass: 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
  },
  {
    type: 'enrichment',
    label: 'Enrichment',
    icon: SquarePlus,
    colorClass: 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
  },
  {
    type: 'expression',
    label: 'Expression',
    icon: SquareFunction,
    colorClass: 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
  },
  {
    type: 'spreading',
    label: 'Spreading',
    icon: SquareAsterisk,
    colorClass: 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
  },
  {
    type: 'filter',
    label: 'Filter',
    icon: SquareScissors,
    colorClass: 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
  },
];

export const getTransformConfig = (type: PlaybookTransformConfig['type']) => {
  return PLAYBOOK_TRANSFORM_CONFIGS.find(config => config.type === type);
};
